module.exports = __webpack_public_path__ + "media/images/footer-fb-icon-90062d461e883f49f4ca6fca61000c5a.png";